<!--  -->
<template>
  <div class="sdwrw">
    <!-- <div class="serch_box">
      <div>
        <el-input v-model="query.keywords" clearable style="width:200px;margin-right:10px" placeholder="请输入标题" />
        <el-select v-model="query.onlyMe" placeholder="请选择" style="margin-left:20px">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <el-button icon="el-icon-circle-plus" type="success" @click="add">新增</el-button>
      </div>
    </div> -->
    <el-table
      border
      :data="taskdata"
      style="width: 100%"
    >
      <el-table-column
        prop="task_info_no"
        label="推送任务编号"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="公众号APPID"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        align="center"
      />
      <el-table-column
        prop="send_open_id_count"
        label="已发送人数"
        align="center"
      />
      <el-table-column
        prop="success_count"
        label="发送成功人数"
        align="center"
      />
      <el-table-column
        prop="fail_count"
        label="发送失败人数"
        align="center"
      />
      <el-table-column
        align="center"
        prop="send_status_text"
        label="发送状态"
      />
      <el-table-column
        align="center"
        prop="send_time_text"
        label="发送时间"
      />
      <el-table-column
        align="center"
        prop="created_at_text"
        label="创建时间"
      />
      <el-table-column
        align="center"
        prop="realName"
        label="创建人"
      />
      <el-table-column
        align="center"
        prop="remark"
        label="备注"
      />
      <el-table-column
        label="操作"
        align="center"
        width="120"
      >
        <!-- <template v-if="scope.row.send_status_text=='未发送'&&show" slot-scope="scope"> -->
        <template v-if="scope.row.send_status==1" slot-scope="scope">
          <el-button type="warning" size="small" @click="stoptask(scope.row)">停止推送</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { infoList, stopSendPushInfo } from '@/api/numberTemplatemessage.js'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        id: ''
      },
      total: null,
      taskdata: [],
      task_info_no: '',
      show: true
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    send(id) {
      console.log('send id', id)
      this.query.id = id
      this.List()
    },
    async List() {
      const data = await infoList(this.query)
      this.taskdata = data.data.list
      this.total = data.data.total
      console.log('this.templatedata', data, this.taskdata)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.List()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.List()
    },
    searchclick() {
      this.query.page = 1
      this.List()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = ''
      this.List()
    },
    add() {
      this.dialogVisible = true
    },
    creatsuccessclose() {
      console.log('111')
      this.dialogVisible = false
    },
    stoptask(row) {
      this.task_info_no = row.task_info_no
      console.log('row.task_info_no', row.task_info_no)
      this.$confirm('确定要停止推送吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const datas = await stopSendPushInfo({ task_info_no: this.task_info_no })
        console.log('datas---', datas)
        if (datas.code === 200) {
          this.$message({
            type: 'success',
            message: '已停止!'
          })
          this.show = false
          this.List()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停止'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sdwrw{
  padding: 0px !important;
}
.serch_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}
</style>
